import { ChevronLeft, ChevronRight } from "lucide-react";

/** Wave V — collapsible vertical tab nav (replaces horizontal scroll bar).
 *
 *   tabs: [{ key, label, icon, ... }]
 *   active: string
 *   onPick: (key) => void
 *   collapsed: bool, onToggle: () => void
 */
export default function VerticalTabNav({ tabs, active, onPick,
                                                            collapsed, onToggle, header }) {
  return (
    <nav data-testid="vertical-tab-nav"
        style={{ width: collapsed ? 48 : 200, flexShrink: 0,
                      borderRight: "1px solid var(--pf-border)",
                      overflowY: "auto", display: "flex", flexDirection: "column",
                      background: "var(--pf-surface-2)",
                      transition: "width 0.18s ease" }}>
      <div style={{ padding: collapsed ? "10px 8px" : "10px 12px",
                          borderBottom: "1px solid var(--pf-border)",
                          display: "flex", alignItems: "center",
                          justifyContent: collapsed ? "center" : "space-between",
                          minHeight: 40 }}>
        {!collapsed && header}
        <button data-testid="vertical-nav-collapse"
            onClick={onToggle}
            style={{ background: "transparent", border: "none",
                          color: "var(--pf-text-muted)", cursor: "pointer",
                          padding: 4 }}
            title={collapsed ? "Expand navigation" : "Collapse navigation"}>
          {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
        </button>
      </div>
      <div style={{ flex: 1, padding: "6px 0" }}>
        {tabs.map((t) => {
          const Icon = t.icon;
          const isActive = active === t.key;
          return (
            <button key={t.key} type="button"
                onClick={() => onPick(t.key)}
                data-testid={`vtab-${t.key}`}
                title={collapsed ? t.label : undefined}
                style={{ width: "100%", textAlign: "left", border: "none",
                              background: isActive ? "var(--pf-surface)" : "transparent",
                              padding: collapsed ? "10px" : "9px 14px",
                              cursor: "pointer",
                              display: "flex", alignItems: "center",
                              justifyContent: collapsed ? "center" : "flex-start",
                              gap: 10,
                              color: isActive ? "var(--pf-text)" : "var(--pf-text-muted)",
                              borderLeft: isActive ? "2px solid var(--pf-spark)" : "2px solid transparent",
                              fontWeight: isActive ? 600 : 400, fontSize: 12.5 }}>
              <Icon size={14} style={{ flexShrink: 0,
                                                color: isActive ? "var(--pf-spark)" : "var(--pf-text-dim)" }} />
              {!collapsed && <span style={{ whiteSpace: "nowrap",
                                                              overflow: "hidden",
                                                              textOverflow: "ellipsis" }}>{t.label}</span>}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
